import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsSubComponent, PmsSubComponent } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsSubComponent>
    useData={usePmsSubComponent}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
